module.exports = __webpack_public_path__ + "static/media/home-2026-eng.a3a6a56f.jpg";